//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TrackingType {
	Home = 0,
	Product = 1,
	Category = 2,
	Basket = 3,
	Checkout = 4,
	Order = 5,
	SearchResults = 6,
	Brand = 7,
	Attribute = 8,
	Wishlist = 9,
	Other = 10
}
